export default __webpack_public_path__ + "static/media/Itihaas.bd0c2de4.jpeg";